import { resolveJoinPackageOrderSummary } from './joinPackageDuration.js';

export function resolvePackageForBooking(booking) {
  const trek = booking?.batch?.trek;
  if (booking?.joinFromPackage?.id) return booking.joinFromPackage;
  if (booking?.registration?.package?.id) return booking.registration.package;

  const packages = trek?.packages || [];
  const joinId = booking?.joinFromPackageId ?? booking?.registration?.packageId ?? null;
  if (joinId != null && String(joinId).trim() !== '') {
    const fromTrek = packages.find((p) => String(p.id) === String(joinId));
    if (fromTrek) return fromTrek;
  }
  return packages.find((p) => p.isMain) || packages[0] || null;
}

export function resolveBookingPackageDates(booking) {
  const batch = booking?.batch;
  const trek = batch?.trek;
  const pkg = resolvePackageForBooking(booking);
  const mainPackage = (trek?.packages || []).find((p) => p.isMain) || pkg;
  return resolveJoinPackageOrderSummary(pkg, {
    mainPackage,
    batchStartDate: batch?.startDate,
    batchEndDate: batch?.endDate,
    allScheduleDays: trek?.scheduleDays || trek?.schedule_days || []
  });
}

export function bookingPackageStartDate(booking) {
  return resolveBookingPackageDates(booking).startDate || booking?.batch?.startDate || null;
}

export function bookingPackageEndDate(booking) {
  return resolveBookingPackageDates(booking).endDate || booking?.batch?.endDate || null;
}

export function formatBookingPackageDateLabel(booking, formatDate) {
  const { startDate, endDate } = resolveBookingPackageDates(booking);
  const fmt =
    formatDate ||
    ((d) =>
      new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }));
  if (!startDate && !endDate) return '—';
  const start = startDate ? fmt(startDate) : '—';
  const end = endDate ? fmt(endDate) : '';
  if (!endDate || start === end) return start;
  return `${start} – ${end}`;
}
